import Vue from 'vue';

// plugins
import VueRouter from 'vue-router';
import VueBootstrap from 'bootstrap-vue';
import VueInsProgressBar from 'vue-ins-progress-bar';
import VuePanel from './plugins';
import VueCustomScrollbar from 'vue-custom-scrollbar';
import VueNotification from 'vue-notification';
import {localize} from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import ru from 'vee-validate/dist/locale/ru.json';
localize({ru});
localize('ru');
import VueGoodTable from 'vue-good-table';
import VueSelect from 'vue-select';
import LazyTube from "vue-lazytube";

// plugins css
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'simple-line-icons/css/simple-line-icons.css';
import 'sweetalert2/dist/sweetalert2.min.css';
// color admin css
import './css/default/app.min.css';
import 'bootstrap-social/bootstrap-social.css';
import 'vue-good-table/dist/vue-good-table.css';
import 'vue-select/dist/vue-select.css';

import App from './App.vue';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueBootstrap);
Vue.use(VuePanel);
Vue.use(VueNotification);
Vue.use(VueSweetalert2);
Vue.component('vue-custom-scrollbar', VueCustomScrollbar);
Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '12px',
});
Vue.use(VueGoodTable);
Vue.component('v-select', VueSelect);
Vue.use(LazyTube);

import Login from './pages/Login.vue';
import Register from './pages/Register.vue';
import Logout from './pages/Logout.vue';
import ForgotPassword from './pages/ForgotPassword.vue';
import ResetPassword from './pages/ResetPassword.vue';
import EmailConfirm from './pages/EmailConfirm.vue';

import MyPage from './pages/MyPage.vue';

import TaskList from './pages/TaskList.vue';
import TaskShow from './pages/TaskShow.vue';
import TaskPromote from './pages/TaskPromote.vue';
import TaskForm from './pages/TaskForm.vue';

import TaskReviewList from './pages/TaskReviewList.vue';
import TaskReview from './pages/TaskReview.vue';

import Support from './pages/SupportLight.vue';
import Howtowork from './pages/Howtowork.vue';

import SupportAdmin from './pages/SupportAdmin.vue';

import NotificationList from './pages/NotificationList.vue';

import Job from './pages/JobList.vue';
import JobShow from './pages/JobShow.vue';

import Profile from './pages/Profile.vue';
import Password from './pages/Password.vue';
import Referral from './pages/Referral.vue';
import Help from './pages/Help.vue';
import Home from './pages/Home.vue';
import Payout from './pages/Payout.vue';
import Payin from './pages/Payin.vue';
import Arbitrage from './pages/Arbitrage.vue';
import AdminPayout from './pages/AdminPayout.vue';
import AdminUserShow from './pages/AdminUserShow.vue';
import ContestRef from './pages/ContestRef.vue';
import ContestAdv from './pages/ContestAdv.vue';
import Top from './pages/Top.vue';
import PayHistories from './pages/PayHistories.vue';
import Rules from './pages/Rules.vue';
import Stats from './pages/Stats.vue';
import Balance from './pages/Balance.vue';
import Rating from './pages/Rating.vue';
import HowToScreen from './pages/HowToScreen.vue';

const routes = [
  {path: '/mypage', component: MyPage, name: 'MyPage'},

  {path: '/', component: TaskList, name: 'TaskList'},
  {path: '/task/create', component: TaskForm, name: 'TaskCreate'},
  {path: '/task/:id/edit', component: TaskForm, name: 'TaskEdit'},
  {path: '/task/:id/show', component: TaskShow, name: 'TaskShow'},
  {path: '/task/:id/promote', component: TaskPromote, name: 'TaskPromote'},

  {path: '/review', component: TaskReviewList, name: 'TaskReviewList'},
  {path: '/task/:id/review', component: TaskReview, name: 'TaskReview'},

  {path: '/jobs/:status', component: Job, name: 'Job'},
  {path: '/job/:id/show', component: JobShow, name: 'JobShow'},

  {path: '/tasks/:status', component: TaskList, name: 'Task'},

  {path: '/support', component: Support, name: 'Support'},
  {path: '/howtowork', component: Howtowork, name: 'Howtowork'},


  {path: '/admin', component: SupportAdmin, name: 'SupportAdmin'},

  {
    path: '/notification',
    component: NotificationList,
    name: 'NotificationList',
  },
  {path: '/home', component: Home, name: 'Home'},
  {path: '/login', component: Login, name: 'Login'},
  {path: '/register', component: Register, name: 'Register'},
  {path: '/logout', component: Logout, name: 'Logout'},
  {
    path: '/forgot-password',
    component: ForgotPassword,
    name: 'ForgotPassword',
  },
  {
    path: '/reset-password/:email',
    component: ResetPassword,
    name: 'ResetPassword',
  },
  {
    path: '/email-confirm/:email',
    component: EmailConfirm,
    name: 'EmailConfirm',
  },
  {path: '/profile', component: Profile, name: 'Profile'},
  {path: '/password', component: Password, name: 'Password'},
  {path: '/referral', component: Referral, name: 'Referral'},
  {path: '/help', component: Help, name: 'Help'},
  {path: '/payout', component: Payout, name: 'Payout'},
  {path: '/payin', component: Payin, name: 'Payin'},
  {path: '/payin/:status', component: Payin, name: 'Payin'},
  {path: '/arbitrage', component: Arbitrage, name: 'Arbitrage'},
  {path: '/admin_payout', component: AdminPayout, name: 'AdminPayout'},
  {
    path: '/admin_user_show/:id',
    component: AdminUserShow,
    name: 'AdminUserShow',
  },
  {path: '/contest_ref', component: ContestRef, name: 'ContestRef'},
  {
    path: '/contest_adv',
    component: ContestAdv,
    name: 'ContestAdv',
  },
  {path: '/top', component: Top, name: 'Top'},
  {path: '/pay_histories', component: PayHistories, name: 'PayHistories'},
  {path: '/rules', component: Rules, name: 'Rules'},
  {path: '/stats', component: Stats, name: 'Stats'},
  {path: '/balance', component: Balance, name: 'Balance'},
  {path: '/rating', component: Rating, name: 'Rating'},
  {path: '/howtoscreen', component: HowToScreen, name: 'HowToScreen'},
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name == 'EmailConfirm') {
    next();
  } else if (to.name == 'ResetPassword') {
    next();
  } else if (to.name == 'ForgotPassword') {
    next();
  } else if (to.name == 'Rules') {
    next();
  }
  if (!localStorage.getItem('access_token')) {
    if (
      to.name == 'Login' ||
      to.name == 'Register' ||
      to.name == 'ForgotPassword' ||
      to.name == 'EmailConfirm' ||
      to.name == 'ResetPassword' ||
      to.name == 'Rules'
    ) {
      next();
    } else {
      next({name: 'Login'});
    }
  } else {
    if (to.name == 'Login') {
      console.log('to=',to)
      next({
        name: 'Profile', query: {
          token: to.query.token,
        }
      });
    } if (to.name == 'Register') {
      next({name: 'Home'});
    } else {
      next();
    }
  }
});

window.eventBus = new Vue();

new Vue({
  render: (h) => h(App),
  router,
}).$mount('#app');
